export class CitrusAdState {
	sku: string;
	adId: string;
}
